import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import ToastMessage from '../../common/ToastMessage';
import { toast } from 'react-toastify';
import useDate from '../../../utils/useDate';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';
import * as yup from 'yup';

const useProviderSelfRegistration = () => {
  const formFields = {
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    confirmEmail: '',
    comments: '',
  };
  const steps = [
    'providerType',
    'providerInfo',
    'userInfo',
    'reviewInfo',
    'success',
  ];
  const { formatDate } = useDate();
  const [currentStep, setCurrentStep] = useState(0);
  const [providerType, setProviderType] = useState();

  const [facilityFieldList, setFacilityFieldList] = useState();
  const [PhysicianFieldList, setPhysicianFieldList] = useState();

  const [AllowFacilityRegistration, setAllowFacilityRegistration] = useState();
  const [AllowPhysicianRegistration, setAllowPhysicianRegistration] =
    useState();

  const [userInformationData, setUserInformationData] = useState(formFields);
  const [userFormData, setUserFormData] = useState(formFields);
  const [valideUser, setValideUser] = useState(true);
  const [approvalRequiredFlag, setApprovalRequiredFlag] = useState();

  const navigate = useNavigate();
  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const userInfoFormSchema = yup.object({
    firstName: yup
      .string()
      .max(35, ' Enter maximum 35 characters only')
      .required(' Enter First Name'),
    middleName: yup.string().max(25, ' Enter maximum 25 characters only'),
    lastName: yup
      .string()
      .max(60, ' Enter maximum 60 characters only')
      .required(' Enter Last Name'),
    email: yup
      .string()
      .email('Enter Valid Email Address')
      .required('Email Required'),
    confirmEmail: yup
      .string()
      .required('Confirm Email Required')
      .when('email', {
        is: (val) => (val && val.length > 0 ? true : false),
        then: () =>
          yup
            .string()
            .oneOf([yup.ref('email')], 'Both Emails must be the same'),
      }),
    comments: yup.string(),
  });

  const unserInfoHandleInput = (e, setFieldValue, handleChange) => {
    handleChange(e);

    setUserFormData({
      ...userFormData,
      [e.currentTarget.name]: e.currentTarget.value,
    });
    setFieldValue(e.currentTarget.name, e.currentTarget.value);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };
  const selectProviderType = (type) => () => {
    setProviderType(type);
    nextStep();
  };

  const extractConfigurationData = (data) => {
    setAllowFacilityRegistration(
      data.selfProviderRegistrationDTO[0].AllowfacilityToRegister,
    );
    setAllowPhysicianRegistration(
      data.selfProviderRegistrationDTO[0].AllowPhysicianToRegister,
    );
    setApprovalRequiredFlag(
      data.selfProviderRegistrationDTO[0].ApprovalRequired,
    );

    const physicianFields =
      data.providerValidationConfigDTO.length &&
      data.providerValidationConfigDTO.filter(
        (item) => item.Display === true && item.ProviderType === 'Physician',
      );
    const facilityFields =
      data.providerValidationConfigDTO.length &&
      data.providerValidationConfigDTO.filter(
        (item) => item.ProviderType === 'Facility' && item.Display === true,
      );
    setFacilityFieldList(facilityFields);
    setPhysicianFieldList(physicianFields);
  };

  const fetchProviderConfiguration = async () => {
    try {
      const configuration = await axiosInstance.get(`
        ${APIEndpoints.getProviderRegistrationConfiguration()}/mandatory/true/display/true/`);
      extractConfigurationData(configuration?.data?.Response);
    } catch (err) {
      return err;
    }
  };

  const validateExistingUserInfo = async (values) => {
    //please put API integration for user validation
    try {
      const emailValidation = await axiosInstance.get(
        APIEndpoints.getUserIDCheckAPIResource() + values.email,
      );
      if (emailValidation.status === 200) {
        setValideUser(false);
        toast.error(
          <ToastMessage
            type="error"
            subTitle="Email already in use. Try using a different email address."
          />,
        );
      }
    } catch (err) {
      if (err.response.status === 404) {
        nextStep();
      } else {
        setValideUser(false);
        toast.error(
          <ToastMessage
            type="error"
            subTitle="Something went wrong, please try again after sometime"
          />,
        );
      }
    }
  };

  useEffect(() => {
    currentStep < 0 && navigate('/admin');
    currentStep < 1 && fetchProviderConfiguration();
  }, [currentStep]);

  const DoctorFormFields = {
    speciality: '',
    previousclaimnumber: '',
    physicianslastname: '',
    physiciansfirstname: '',
    physicianssocialsecuritynumber: '',
    email: '',
    facilityaddressline1: '',
    facilityaddressline3: '',
    facilitycity: '',
    facilitystate: '',
    physiciancertificatenumber: '',
    phone: '',
    physicianalternateid1: '',
    physicianalternateid2: '',
    licensestate: '',
    licensenumber: '',
    facilitytaxid: '',
    facilitypostalcode: '',
    facilityname: '',
    facilitynpi: '',
    facilitylicensestate: '',
    facilitylicensenumber: '',
    facilitycertificatenumber: '',
    facilityalternateid2: '',
    facilityalternateid1: '',
    billingtaxid: '',
    physiciansdateofbirth: '',
  };

  const facilityFormFields = {
    Speciality: '',
    Previousclaimnumber: '',
    PhysiciansSocialSecurityNumber: '',
    PhysiciansLastName: '',
    PhysiciansFirstName: '',
    PhysiciansDateofBirth: '',
    PhysiciansCertificateNumber: '',
    PhysicianNPI: '',
    PhysicianAlternateID2: '',
    PhysicianAlternateID1: '',
    Phone: '',
    LicenseState: '',
    LicenseNumber: '',
    FacilityTaxId: '',
    FacilityState: '',
    FacilityPostalCode: '',
    FacilityName: '',
    FacilityNPI: '',
    FacilityLicenseState: '',
    FacilityLicenseNumber: '',
    FacilityCity: '',
    FacilityCertificateNumber: '',
    FacilityAlternateID2: '',
    FacilityAlternateID1: '',
    FacilityAddressLine1: '',
    Email: '',
    BillingTaxID: '',
  };
  const [userData, setUserData] = useState(DoctorFormFields);
  const [formData, setFormData] = useState(DoctorFormFields);

  const [facilityUserData, setFacilityUserData] = useState(facilityFormFields);
  const [facilityFormData, setFacilityFormData] = useState(facilityFormFields);

  const [providerFlowResponse, setProviderFlowResponse] = useState();

  useEffect(() => {
    if (currentStep === 0) {
      setUserData(DoctorFormFields);
      setFormData(DoctorFormFields);
      setFacilityUserData(facilityFormFields);
      setFacilityFormData(facilityFormFields);
    }
    if (currentStep === 1) {
      setUserFormData(formFields);
    }
    console.log('currentStep@@@', currentStep);
  }, [currentStep]);

  const PhysicianValues = {};
  PhysicianFieldList &&
    PhysicianFieldList.map((phys) => {
      const newKey = phys.Fields && phys.Fields.replace(/['#\s]/g, '');
      PhysicianValues[newKey] = phys;
    });
  const facilityValues = {};
  facilityFieldList &&
    facilityFieldList.map((phys) => {
      const newKey = phys.Fields && phys.Fields.replace(/['#\s]/g, '');
      facilityValues[newKey] = phys;
    });

  const handleInput = (e, setFieldValue, handleChange, type) => {
    if (type === 'physiciansdateofbirth') {
      const date = e && formatDate(e);
      if (e) {
        handleChange('physiciansdateofbirth', date);
        setFormData({
          ...formData,
          physiciansdateofbirth: date,
        });
        setFieldValue('physiciansdateofbirth', date);
      }
    } else {
      handleChange(e);
      setFormData({
        ...formData,
        [e.currentTarget.name]:
          type === 'blur'
            ? e.currentTarget.value.trim()
            : e.currentTarget.value,
      });
      setFieldValue(
        e.currentTarget.name,
        type === 'blur' ? e.currentTarget.value.trim() : e.currentTarget.value,
      );
    }
  };

  const handleFacilityInput = (e, setFieldValue, handleChange, type) => {
    handleChange(e);

    setFacilityFormData({
      ...facilityFormData,
      [e.currentTarget.name]:
        type === 'blur' ? e.currentTarget.value.trim() : e.currentTarget.value,
    });
    setFieldValue(
      e.currentTarget.name,
      type === 'blur' ? e.currentTarget.value.trim() : e.currentTarget.value,
    );
  };

  const validateProviderFacility = async () => {
    const doctorPayLoad = {
      ProviderType: 'Provider',
      PhysicianFirstName: formData.physiciansfirstname,
      PhysicianLastName: formData.physicianslastname,
      FacilityEmail: formData.email,
      PhysicianEmail: formData.email,
      previousClaimNumber: formData.previousclaimnumber,
      FacilityAddressLine1: formData.facilityaddressline1,
      FacilityAddressLine3: formData.facilityaddressline3,
      FacilityCity: formData.facilitycity,
      FacilityState: formData.facilitystate,
      PhysicianCertificateNumber: formData.physiciancertificatenumber,
      Phone: formData.phone,
      PhysicianAlternateID1: formData.physicianalternateid1,
      PhysicianAlternateID2: formData.physicianalternateid2,
      LicenseState: formData.licensestate,
      LicenseNumber: formData.licensenumber,
      FacilityTaxId: formData.facilitytaxid,
      FacilityPostalCode: formData.facilitypostalcode,
      FacilityName: formData.facilityname,
      FacilityNPI: formData.facilitynpi,
      PhysicianNPI: formData.physiciannpi,
      FacilityLicenseState: formData.facilitylicensestate,
      FacilityLicenseNumber: formData.facilitylicensenumber,
      FacilityCertificateNumber: formData.facilitycertificatenumber,
      FacilityAlternateID2: formData.facilityalternateid2,
      FacilityAlternateID1: formData.facilityalternateid1,
      BillingTaxID: formData.billingtaxid,
      PhysicianDateOfBirth: formData.physiciansdateofbirth,
      Specialty: formData.speciality,
      PhysicianSocialSecurityNumber: formData.physicianssocialsecuritynumber,
      PhysicianLicenseState: formData.physicianlicensestate,
    };
    const facilityPayload = {
      ProviderType: 'Facility',
      Speciality: facilityFormData.Speciality,
      Previousclaimnumber: facilityFormData.Previousclaimnumber,
      PhysicianSocialSecurityNumber:
        facilityFormData.PhysiciansSocialSecurityNumber,
      PhysicianLastName: facilityFormData.PhysiciansLastName,
      PhysicianFirstName: facilityFormData.PhysiciansFirstName,
      PhysicianDateofBirth: facilityFormData.PhysiciansDateofBirth,
      PhysicianCertificateNumber: facilityFormData.PhysiciansCertificateNumber,
      PhysicianNPI: facilityFormData.PhysicianNPI,
      PhysicianAlternateID2: facilityFormData.PhysicianAlternateID2,
      PhysicianAlternateID1: facilityFormData.PhysicianAlternateID1,
      Phone: facilityFormData.Phone,
      LicenseState: facilityFormData.LicenseState,
      LicenseNumber: facilityFormData.LicenseNumber,
      FacilityTaxId: facilityFormData.FacilityTaxId,
      FacilityState: facilityFormData.FacilityState,
      FacilityPostalCode: facilityFormData.FacilityPostalCode,
      FacilityName: facilityFormData.FacilityName,
      FacilityNPI: facilityFormData.FacilityNPI,
      FacilityLicenseState: facilityFormData.FacilityLicenseState,
      FacilityLicenseNumber: facilityFormData.FacilityLicenseNumber,
      FacilityCity: facilityFormData.FacilityCity,
      FacilityCertificateNumber: facilityFormData.FacilityCertificateNumber,
      FacilityAlternateID2: facilityFormData.FacilityAlternateID2,
      FacilityAlternateID1: facilityFormData.FacilityAlternateID1,
      FacilityAddressLine1: facilityFormData.FacilityAddressLine1,
      Email: facilityFormData.Email,
      BillingTaxID: facilityFormData.BillingTaxID,
    };
    //const payload2 = {
    //ProviderType: 'Provider',
    //FacilityNPI: '2398765432',
    //FacilityName: 'OASIS HOSPITAL 2',
    //FacilityAddressLine1: '750 N 40th St',
    //FacilityCertificateNumber: '100073f18430',
    //PhysicianFirstName: 'Jane',
    //PhysicianLastName: 'goodall',
    //};
    //nextStep();
    try {
      const DoctorFacilityProvider = await axiosInstance.post(
        APIEndpoints.DoctorFacilityProvider(),
        providerType === 'Doctor' ? doctorPayLoad : facilityPayload,
      );
      const doctorFacilityData = DoctorFacilityProvider?.data?.Response;
      setProviderFlowResponse(doctorFacilityData);
      if (
        doctorFacilityData.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        nextStep();
      }
    } catch (error) {
      console.log(error);

      toast.error(
        <ToastMessage
          type="error"
          subTitle="Information you entered does not match our records. Enter correct information and try again."
        />,
      );
    }
  };

  return {
    currentStep,
    steps,
    providerType,
    AllowFacilityRegistration,
    AllowPhysicianRegistration,
    facilityFieldList,
    PhysicianFieldList,
    setCurrentStep,
    nextStep,
    prevStep,
    selectProviderType,
    userData,
    formData,
    handleInput,
    validateProviderFacility,
    PhysicianValues,
    facilityUserData,
    facilityFormData,
    handleFacilityInput,
    facilityValues,
    userInfoFormSchema,
    validateExistingUserInfo,
    userInformationData,
    userFormData,
    unserInfoHandleInput,
    valideUser,
    providerFlowResponse,
    approvalRequiredFlag,
  };
};

export default useProviderSelfRegistration;
